import React, { useEffect, useRef, useState } from 'react';
import useAuth from 'context/useAuth';

import { AppRoutes } from 'routes';

import SessionExpireWarningModal from './SessionExpireWarningModal';

const SessionTimeout = () => {
    const [displayModal, updateModalVisibility] = useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = useState(0);
    const sessionTimeoutRef = useRef(null);
    const timeOutRef = useRef(null);
    const { signOut, user } = useAuth();
    const timer = 14 * 60 * 1000;

    useEffect(() => {
        if (!user) {
            return;
        }
        window.setTimeout(warning, timer);
    }, [user]);

    const startInterval = (countDown) => {
        timeOutRef.current = setInterval(() => {
            if (countDown > 0) {
                setTimeoutCountdown(--countDown);
            }
        }, 1000);
    };

    const warning = () => {
        setTimeout(() => {
            let countDown = 60;
            updateModalVisibility(true);
            sessionTimeoutRef.current = setTimeout(logOut, 60000);
            setTimeoutCountdown(countDown);
            startInterval(countDown);
        }, 1000);
    };

    const handleOnOk = () => {
        updateModalVisibility(false);
    };

    const logOut = () => {
        clearTimeout(sessionTimeoutRef.current);
        clearInterval(timeOutRef.current);
        signOut(AppRoutes.sessionExpiredPage);
    };
    return <SessionExpireWarningModal countDown={timeoutCountdown} onOk={handleOnOk} visible={displayModal} />;
};

export default SessionTimeout;
